export const MAX_VIN_CODE_LENGTH = 17;
export const VIN_CODE_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;
export const LOCAL_STORAGE_KEYS = {
    VIN_CODE: 'vinCode',
    PAYMENT_COMPLETED: 'paymentCompleted',
    IDEMPOTENCY_KEY: 'idempotencyKey',
};
